<template>
  <div class="previewer" :style="sizeData">
    <video v-if="isVideo" class="video" ref="video" :src="url" :poster="videoPoster" controls controlslist="nodownload"></video>
    <template v-else>
      <div class="handler-mask" @mouseenter="enter" @mouseleave="leave" @mousemove="handleMove"></div>
      <div class="main-picture">
        <el-image :src="url" alt="正常图" class="img" fit="contain"></el-image>
      </div>
      <div class="handler" v-show="isShow" :style="{ top: top + 'px', left: left + 'px' }"></div>
      <div class="large-picture" v-show="isShow">
        <img :src="url" alt="大图" :style="{
        top: `${topLgImg}px`,
        left: `${leftLgImg}px`,
        width: `${size * 2}px`,
        height: `${size * 2}px`
      }"/>
      </div>
    </template>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  name: "blog-header",
  data() {
    return {
      timer: null,
      videoType: 'mp4 avi dat 3gp mov rmvb',
      isShow: false, //控制遮罩层marks和大图片是否显示"
      left: 0, //marks左移位置
      top: 0, //marks下移位置
      leftLgImg: 0, //大图lgImg移动的位置
      topLgImg: 0, //大图lgImg移动的位置
    };
  },
  props: {
    size: {
      type: Number,
      default: 440
    },
    url: String,
    videoPoster: String
  },
  computed: {
    sizeData() {
      return {width: `${this.size}px`, height: `${this.size}px`}
    },
    isVideo() {
      const arr = this.url.split('.');
      const suffix = arr[arr.length - 1];
      return this.videoType.indexOf(suffix) > -1;
    }
  },
  methods: {
    enter() {
      this.isShow = true;
    },
    leave() {
      this.isShow = false;
    },
    handleMove(e) {
      const marksWidth = 48; //marks的宽
      const marksHeight = 48; //marks的高
      this.left = e.offsetX - marksWidth / 2;
      this.top = e.offsetY - marksHeight / 2;
      if (this.left < 0) {
        this.left = 0;
      }
      if (this.left > 290) {
        this.left = 290;
      }
      if (this.top < 0) {
        this.top = 0;
      }
      if (this.top > 290) {
        this.top = 290;
      }
      //大d图片除以小的图片的宽高
      this.leftLgImg = (-this.left * this.size * 2) / this.size;
      this.topLgImg = (-this.top * this.size * 2) / this.size;
    }
  }
};
</script>

<style scoped lang='less'>
.previewer {
  position: relative;
  border:1px solid #e9e9e9;

  .handler-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
  }

  .video, .main-picture {
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    outline: none;

    .img {
      width: inherit;
      height: inherit;
    }
  }

  .handler {
    width: 150px;
    height: 150px;
    position: absolute;
    background-color: rgba(220, 220, 220, 0.5);
  }

  .large-picture {
    position: absolute;
    top: 0px;
    left: 100%;
    width: inherit;
    height: inherit;
    overflow: hidden;
    border: 2px solid #aaa;
    background-color: #fff;
    z-index: 90;

    img {
      position: absolute;
      object-fit: contain;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/magnifier.vue